import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * Component used to display back arrow Icon
 * @param props - SvgIconProps
 * @example - <CcfNavigationIcon />
 * @returns SVG of back arrow Icon
 */
export function CcfNavigationIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M7.77358 7.00497L1.35849 0.238806C1.0566 -0.079602 0.528302 -0.079602 0.226415 0.238806C-0.0754717 0.557214 -0.0754717 1.11443 0.226415 1.43284L6.26415 7.80099L0.226415 14.5672C-0.0754717 14.8856 -0.0754717 15.4428 0.226415 15.7612C0.528302 16.0796 1.0566 16.0796 1.35849 15.7612L7.77358 8.59702C8 8.35821 8 8.1194 8 7.8806C8 7.48259 7.92453 7.16418 7.77358 7.00497Z" />
    </SvgIcon>
  );
}

export default CcfNavigationIcon;
